import { render } from "./ButtonMail.vue?vue&type=template&id=6a02da52&scoped=true"
import script from "./ButtonMail.vue?vue&type=script&lang=js"
export * from "./ButtonMail.vue?vue&type=script&lang=js"

import "./ButtonMail.vue?vue&type=style&index=0&id=6a02da52&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vizbi-frontend-test/vizbi-frontend-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a02da52"]])

export default __exports__